import { ActionBase } from '../../../core/store/action/ActionBase';
import { AddRuleConditionGroupModel } from '../../models/AddRuleConditionGroupModel';

export const GROUP_RULE_CONDITIONS = '[DynamicDataSet] Group Rule Conditions';

export class GroupRuleConditionsAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = GROUP_RULE_CONDITIONS;

  constructor(public payload: { dynamicDataSetKey: string; dynamicRuleKey: string; model: AddRuleConditionGroupModel }) { }
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/GroupRuleConditionsAction.ts